export interface CookiePreferences {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
}

const COOKIE_CONSENT_KEY = 'cookieConsent';

export function getCookiePreferences(): CookiePreferences {
  const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch (e) {
      console.error('Error parsing cookie preferences:', e);
    }
  }
  return {
    necessary: true,
    analytics: false,
    marketing: false,
  };
}

export function setCookiePreferences(preferences: CookiePreferences): void {
  localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(preferences));
  updateAnalyticsTracking(preferences);
  updateMarketingTracking(preferences);
}

function updateAnalyticsTracking(preferences: CookiePreferences): void {
  // Here you would implement your analytics tracking logic
  // For example, if using Google Analytics:
  // if (preferences.analytics) {
  //   // Enable analytics
  // } else {
  //   // Disable analytics
  // }
}

function updateMarketingTracking(preferences: CookiePreferences): void {
  // Here you would implement your marketing tracking logic
  // For example, if using marketing pixels:
  // if (preferences.marketing) {
  //   // Enable marketing tracking
  // } else {
  //   // Disable marketing tracking
  // }
} 